import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {Col, Row} from 'react-bootstrap';

import {
    ConservationAction as ConservationActionModel,
    ConservationActionSampleEvent as ConservationActionSampleEventModel,
} from '../../../Models';

import {ConservationActionPhaseFieldViewer} from "../../../Models/Core/FieldViewers/ConservationActionPhaseFieldViewer";
    
import {GenericModelViewer} from "../../Common/GenericModelViewer";
import {ObjectUtils} from "../../../Utils/ObjectUtils";

import {SurveyFormInputEnhance} from "../../Common/SurveyForm";
import {SurveySectionHeader} from "../../Common/SurveyForm";

@SurveyFormInputEnhance
export class ModeledUpliftSurveySection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            surveyType: null,
            validation: {}
        };
    }


    @autobind
    onValidationUpdate() {
        //const { OnValidation } = this.props;

        //SurveyFormInput.MarkValidationStatusValid();

        // TODO

    }

    @autobind
    getSurveyType() {
        const { Survey } = this.props;
        return Survey.SurveyType;
    }

    @autobind
    getModel() {

        let surveyType = this.getSurveyType();
        let conservationActionPhaseId = surveyType?.conservationActionPhaseId;

        if(this.alteredConservationActionModel) {
            // if this.props.Survey.surveyTypeId changed we will potentially
            // need to discard our cached alteredConservationActionModel
            let conservationActionSampleEventsFieldDef = this.alteredConservationActionModel
                .getFlattenedFieldDefs()
                .find( (field) => field.key === "ConservationActionSampleEvents" );

            if(conservationActionSampleEventsFieldDef.model?.defaults?.conservationActionPhaseId == conservationActionPhaseId) {

                return this.alteredConservationActionModel;
            }
        }

        let conservationActionModel = new ConservationActionModel();

        // we modify this model's fieldDefs to present a unique view
        // of model editor on this page
        let alteredConservationActionSampleEventModel = new ConservationActionSampleEventModel();

        // assign a default conservationActionPhaseId value
        alteredConservationActionSampleEventModel.defaults = {
            conservationActionPhaseId: conservationActionPhaseId
        };

        alteredConservationActionSampleEventModel.classNamesFromData = (data) => {
          return "sampleEvent-environmentalBenefitId-" + (data?.SampleEvent?.environmentalBenefitId);
        };

        // and prevent the conservationActionPhaseId value from being editable
        alteredConservationActionSampleEventModel.getFlattenedFieldDefs()
            .find( (field) => field.key === "conservationActionPhaseId" )
            .editor = ConservationActionPhaseFieldViewer;

        // we also modify this (association) fieldDef
        let conservationActionSampleEventsFieldDef = conservationActionModel.getFlattenedFieldDefs()
            .find( (field) => field.key === "ConservationActionSampleEvents" );

        // so it uses our altered ConservationActionSampleEventModel
        conservationActionSampleEventsFieldDef
            .model = alteredConservationActionSampleEventModel;

        // and so it doesn't display it's groupTitle since
        // we already display a title for the survey section
        conservationActionSampleEventsFieldDef
            .groupTitle = '';
        conservationActionSampleEventsFieldDef
            .association.groupTitle = '';

        // and don't hide it (since we are now hiding it on the Summary page)
        conservationActionSampleEventsFieldDef
            .isHidden = false;
        conservationActionSampleEventsFieldDef
            .association.isHidden = false;

        return this.alteredConservationActionModel = conservationActionModel;
    }

    @autobind
    static filterConservationActionSampleEventsBySurveyType(conservationAction, surveyType) {

        if(!conservationAction || !surveyType) {
            return [];
        }

        const conservationActionPhaseId = surveyType?.conservationActionPhaseId;

        // filter our modeled uplift to just the appropriate
        // conservationActionPhaseId for the given surveyTypeId
        return conservationAction.ConservationActionSampleEvents
            .filter((casEvent) =>
                casEvent.conservationActionPhaseId === conservationActionPhaseId &&
                casEvent.isCurrentModelingEvent !== false
                // && casEvent.SampleEvent.sampleEventTypeId === 2 // ignore monitoring events (this isn't need because of above)
            );
    }

    render() {
        const { EditMode, ConservationAction, OnConservationActionChange, OnSave, Section, id, Header, Footer } = this.props;

        let editable = EditMode;

        let surveyType = this.getSurveyType();

        // all ConservationAction field groups are hidden except ConservationActionSampleEvents (Modeled Uplift)
        let model = this.getModel();
        let hiddenGroups = model.getFieldDefGroups().filter((group) => group.key !== "Modeled Uplift").map((x) => x.key);

        // all ConservationActionSampleEvents are hidden except the
        // Modeling Events that are relevant to the current survey (surveyTypeId)
        let conservationAction = ObjectUtils.Clone(ConservationAction);
        conservationAction.ConservationActionSampleEvents = this.constructor.filterConservationActionSampleEventsBySurveyType(conservationAction, surveyType);

        // irrigation upgrades are synced from Fulcrum instead of being entered manually
        if(conservationAction?.ConservationActionType?.code === 'irrigation-upgrade') {
            editable = false;
        }

        return <Col key={Section.surveySectionId} id={id}>
            { Header ?? <SurveySectionHeader section={Section} /> }
            <Row>
                <Col xs={12}>

                        <GenericModelViewer
                            className={"sb-survey-form-table"}

                            Data={conservationAction}

                            EditMode={editable}
                            HideGroups={hiddenGroups}
                            IsNewModel={false}
                            Model={model}
                            OnValidationUpdate={this.onValidationUpdate}
                            RootData={conservationAction}
                            SkipBorder={false}
                            Update={OnConservationActionChange}

                        />

                </Col>
            </Row>
            {Footer ?? null}
        </Col>;
    }
}
